/**
 * A guest who signs into an *existing* account switches to that account's uid, so the result they
 * earned as a guest is still stamped with the guest uid and the profile (which lists
 * `results where userId == uid`) never finds it. This builds the account's own copy of it.
 *
 * Returns null when there is nothing to move: linking a guest to a new account keeps the same uid,
 * so its results already belong to it.
 */
export const claimedCopy = (results, uid) => {
  if (!results?.resultId || !uid || results.userId === uid) return null;
  const { submittedAt } = results;
  // Round-trip drops `undefined` values, which Firestore rejects.
  const copy = JSON.parse(JSON.stringify(results));
  copy.userId = uid;
  // Stable id, so retrying the move rewrites the same document instead of adding duplicates.
  copy.resultId = `${results.resultId}_${uid.slice(0, 8)}`;
  // Keep it a real date (stored as a Firestore Timestamp), whatever shape it arrived in.
  copy.submittedAt = submittedAt?.toDate ? submittedAt.toDate() : submittedAt ? new Date(submittedAt) : new Date();
  return copy;
};
